<template>
  <div>
    <div class="card" style="height: 142px">
      <tk-flex middle center>
        <tk-image :src="require(`../../assets/images/${image}.png`)" style="height: 68px; width: 68px" />
        <tk-flex column middle class="m-l-16">
          <div style="font-size:24px; color:#152137;">{{count}}<span style="font-size:14px; color:#152137">{{unit}}</span></div>
          <div style="font-size:14px;">{{title}}</div>
        </tk-flex>
      </tk-flex>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.card{
  padding-left: 24px;
  display: flex;
  align-items: center;
  background: white;
}

</style>
